import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { ArrowLeft } from "lucide-react";

const LegalLayout = ({ title, description, path, children }) => (
  <>
    <Seo title={title} description={description} path={path} />
    <section className="bg-[#0A0A0A] pb-24 pt-40 md:pt-52">
      <div className="mx-auto max-w-3xl px-5 md:px-10">
        <Link to="/" className="group inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#8C8C8C] transition-colors hover:text-[#2FBF8F]">
          <ArrowLeft size={13} className="transition-transform duration-300 group-hover:-translate-x-1" /> Accueil
        </Link>
        <h1 className="mt-8 font-serif text-4xl font-light text-[#F4F4F0] md:text-5xl">{title.split(" | ")[0]}</h1>
        <div className="mt-10 space-y-8 text-sm leading-relaxed text-[#8C8C8C]">{children}</div>
      </div>
    </section>
  </>
);

const H2 = ({ children }) => <h2 className="pt-4 font-serif text-2xl font-light text-[#F4F4F0]">{children}</h2>;

export const MentionsLegales = () => (
  <LegalLayout
    title="Mentions légales | Resineko"
    description="Mentions légales du site Resineko, spécialiste des revêtements de sols en résine, béton ciré et moquette de pierre."
    path="/mentions-legales"
  >
    <H2>Éditeur du site</H2>
    <p>Le site est édité par Resineko, entreprise individuelle spécialisée dans les revêtements de sols en résine, le béton ciré, la moquette de pierre et la peinture en bâtiment, basée à Daux (31700), dans la région toulousaine, et intervenant partout en France. Téléphone : 07 83 69 31 01 — Email : resineko31@gmail.com — SIRET : 844 714 089 00027.</p>
    <H2>Hébergement</H2>
    <p>Le site est hébergé sur une infrastructure cloud sécurisée. Les informations détaillées de l'hébergeur seront précisées sur cette page.</p>
    <H2>Propriété intellectuelle</H2>
    <p>L'ensemble des contenus du site (textes, visuels, identité graphique) est protégé. Toute reproduction sans autorisation préalable est interdite.</p>
    <H2>Visuels</H2>
    <p>Certaines photographies du site sont des visuels d'illustration et ne représentent pas des réalisations de Resineko. Les photographies de chantiers publiées sur la page Réalisations sont clairement identifiées.</p>
  </LegalLayout>
);

export const PolitiqueConfidentialite = () => (
  <LegalLayout
    title="Politique de confidentialité | Resineko"
    description="Politique de confidentialité du site Resineko : données collectées via le formulaire de devis, finalités et droits des utilisateurs."
    path="/politique-de-confidentialite"
  >
    <H2>Données collectées</H2>
    <p>Le formulaire de demande de devis collecte les informations suivantes : prénom, nom, téléphone, email, ville, type de client et de projet, surface approximative, revêtement recherché, description du projet et, le cas échéant, photos transmises volontairement.</p>
    <H2>Finalité</H2>
    <p>Ces informations sont utilisées exclusivement pour traiter votre demande de devis et échanger avec vous au sujet de votre projet. Elles ne font l'objet d'aucune cession à des tiers ni d'aucune prospection commerciale non sollicitée.</p>
    <H2>Conservation</H2>
    <p>Les demandes sont conservées pendant la durée nécessaire au traitement de votre projet.</p>
    <H2>Vos droits</H2>
    <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, contactez-nous via le formulaire de contact du site.</p>
  </LegalLayout>
);

export const CookiesPage = () => (
  <LegalLayout
    title="Cookies | Resineko"
    description="Politique d'utilisation des cookies du site Resineko."
    path="/cookies"
  >
    <H2>Cookies utilisés</H2>
    <p>Le site Resineko n'utilise pas de cookies publicitaires ni de traceurs tiers à des fins marketing. Seuls des éléments techniques strictement nécessaires au fonctionnement du site peuvent être stockés sur votre appareil.</p>
    <H2>Gestion</H2>
    <p>Vous pouvez à tout moment configurer votre navigateur pour refuser le dépôt de cookies. Aucune fonctionnalité essentielle du site ne dépend de cookies non nécessaires.</p>
  </LegalLayout>
);
